export type Point = [number, number];

export function distance2_between_points([x, y]: Point, [x2, y2]: Point): number {
    const dx = x - x2;
    const dy = y - y2;
    return dx * dx + dy * dy;
}

export function distance_between_points(a: Point, b: Point): number {
    return Math.sqrt(distance2_between_points(a, b));
}

export function direction_between(from: Point, to: Point): Point {
    const [x, y] = from;
    const [x2, y2] = to;
    const dx = x2 - x;
    const dy = y2 - y;
    const dist = Math.sqrt(dx * dx + dy * dy);
    return [
        dx / dist,
        dy / dist,
    ];
}